export const statusColors = {
  pending_review: 'bg-yellow-100 text-yellow-800',
  approved: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  inspection_required: 'bg-blue-100 text-blue-800',
  booked: 'bg-purple-100 text-purple-800',
  pending: 'bg-orange-100 text-orange-800',
  archived: 'bg-gray-100 text-gray-800'
};
